(function() {
	'use strict';

	angular.module('app.dashboard')
	.controller('leanProjectMonthlySavingsCtrl', leanProjectMonthlySavingsCtrl);

	function leanProjectMonthlySavingsCtrl($rootScope, $scope, $timeout, config, savingsType, dashboardFilterInitializationService, 
			leanProjectMonthlySavingsService, pageTimingService, siteService, leanFilterService, storeService) {
		var projectMonthlySavingsProperties = {
			translation: {
				'totalSavings': 'Total Savings',
				'weightedTotalSavings': 'Weighted Total Savings',
				'annualSavings': 'Annual Savings',
				'oneTimeSavings': 'One Time Savings',
				'costAvoidence': 'Cost Avoidance',
				'implementationCost': 'Implementation Cost'
			}
		};
		var configStr;
		$scope.modelDetails = $scope.$parent.model;
		if (!config.savingsType) {
			configStr = $scope.modelDetails.configStr ? JSON.parse($scope.modelDetails.configStr) : {};
		} else {
			configStr = config;
		}

		savingsType = configStr['savingsType'];
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.$parent.$parent.showViewReport = true;
		$scope.savingsType = savingsType;
		$scope.lastSavingsType = savingsType;
		$scope.$parent.$parent.hidePencil = true;
		$scope.savingsSelect = false;
		$scope.firstTime = !savingsType;
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;

		if (!$scope.$parent.content.defaultDrillDownUrl) {
			$scope.$parent.content.defaultDrillDownUrl = $scope.$parent.content.drillDownUrl;
		}

		$scope.slideshowView = $rootScope.slideshowView;

		$scope.$parent.$parent.editWidgetSettings = function () {
			$scope.savingsSelect = true;
			$scope.$parent.$parent.hidePencil = true;
		};

		function updateConfig() {
			var model = $scope.$$childTail ? $scope.$$childTail.model: $scope.$parent.$$childTail.model;
			model.config.savingsType = $scope.savingsType;
			$scope.lastSavingsType = $scope.savingsType;
			var columnDefinition = $scope.$parent.$parent.col;
			storeService.dispatch({
				type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
				payload: {
					column: 'column' + columnDefinition.columnIndex,
					position: columnDefinition.widgets.indexOf(model),
					widget: {
						name: model.config.type,
						config: _.cloneDeep(model.config)
					}
				},
				meta: {
					reportName: undefined,
					reportSettingsId: globalReportName
				}
			});
		}

		$scope.closeDialog = function() {
			$scope.savingsSelect = false;
			$scope.$parent.$parent.hidePencil = false;
		};

		$scope.saveSavings = function () {
			if (!$scope.savingsType) {
				$scope.savingsSelect = true;
			}
			else if ($scope.savingsType !== null && $scope.savingsType != $scope.lastSavingsType) {
				$scope.savingsSelect = false;
				$scope.firstTime = false;
				pendo.track('widgetChangeConfig', {
					widgetType: $scope.config.type,
					savingsType: $scope.savingsType
				});
				updateConfig();
				getChart();
			} else {
				$scope.savingsSelect = false;
				$scope.$parent.$parent.hidePencil = false;
			}
		};
		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'leanProjectFilterChanged']);

		function setWidgetName() {
			$scope.$parent.$parent.definition.config.title = 'Lean Project Cumulative Savings';
		}

		function getChart() {
			// this widget uses the metric-chart directive which needs this data
			var metric = {
				chartType: 'MSColumn2D',
				displayResolutionType: 'Monthly',
				displayType: 'currency',
				goalType: 'Above',
				isCategorized: false,
				yAxisLabel: 'Actual'
			};
			if (!$scope.savingsType) {
				$scope.savingsType = 'totalSavings';
				$scope.savingsSelect = false;
				updateConfig();
			}

			setWidgetName();
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;
			leanProjectMonthlySavingsService.getLeanProjectMonthlySavings($scope.leanFilterService, $scope.savingsType)
				.then(
					function(d) {
						$scope.savingsSelect = false;
						d.metricConfig = metric;
						$scope.empty = false;
						// accumulate values
						var sum = 0.0;
						for (var i = 0; i < d.results.length; i++) {
							sum += d.results[i].value;
							d.results[i].value = sum;
						}
						sum = 0.0;
						for (i = 0; i < d.targets.length; i++) {
							sum += d.targets[i].value;
							d.targets[i].value = sum;
						}
						$scope.empty = !d.targets.length && !d.results.length;
						$scope.chartData = d;
						$scope.currencySymbol = d.currency;
						$scope.$broadcast('event:metricCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
						$scope.$parent.$parent.hidePencil = true;
					},
					function(e) {
						$scope.empty = true;
						$scope.savingsSelect = false;
						$scope.chartData = {'metricConfig': metric, 'results': [], 'targets': []};
						$scope.$broadcast('event:metricCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
						$scope.$parent.$parent.hidePencil = true;
					}
				);
		}

		var loadData = function() {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				getChart();
			} else {
				$timeout(loadData, 100);
			}
		};

		loadData();
	}
})();
